import FORMAT_VALIDATIONS from '@/services/formatter_services/enums/FORMAT_VALIDATIONS';

const DECIMAL_CONFIG = Object.freeze({
  'de': {
    replacements: (value) => {
      return value.replace(/\./g, '').replace(/,/g, '.')
    },
    validations: [
      (v) => FORMAT_VALIDATIONS.ONLY_ONE(',', v),
      (v) => FORMAT_VALIDATIONS.MAX_N_AFTER(',', 4, v),
      (v) => FORMAT_VALIDATIONS.MAX_N_BEFORE(',', 10, v),
      (v) => FORMAT_VALIDATIONS.CHAR_ONLY_AT_START('-', 0, v),
    ]
  }
});

const getConfigOf = (locale) => {
  return DECIMAL_CONFIG[locale];
}

export { DECIMAL_CONFIG, getConfigOf };
